//If we need translations for testing purposes in the future, uncomment I guess.
//const rootUrl = "REACT_APP_API_URL" in process.env ? process.env.REACT_APP_API_URL : 'https://api.connome.com/api/'
const rootUrl = 'https://api.connome.com/api/'
/**
 * 
 * Language can be specified in the same manner as the HTTP Header Field Accept-Language,
 * like 'en-US', 'nb-NO', 'da-DK', 'sv-SE' (or just 'en', 'nb', 'da', 'sv').
 * 
 * @param {*} language 
 * @param {*} onOk 
 * @param {*} onError 
 */
export function downloadTranslations(language, onTranslationsDownloaded, onError) {
    const query = "AppView/Translation/" + language;
    console.log("Request: " + query);

    const myHeaders = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
    });

    fetch(rootUrl + query, {
        headers: myHeaders,
        method: 'GET'
    })
        .then(function (response) {
            if (response.status !== 401) {
                return response.json();
            } else {
                console.log("Response status: " + response.status);
            }
        })
        .then(function (data) {
            onTranslationsDownloaded(data);
        })
        .catch(error => console.log('Something bad happened: ' + error));
}


// WEBPACK FOOTER //
// ./src/Networking/TranslationGetter.js